import { IdModal } from "../../../modals/IdModal";
import { createPathSelectTabInModal } from "../../../show-me/path/createPathSelectTabInModal";
import { IdStoreCategory } from "../../../store/IdStoreCategory";
export var pathSelectDogTreatInStoreMenu = function (action, state$, deps) {
    return createPathSelectTabInModal(function () { return IdModal.Store; }, function () { return IdStoreCategory.TreatShop; })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/paths/pathSelectDogTreatInStoreMenu.ts
// module id = 1908
// module chunks = 3